import Grid from '../../icons/Gridded.svg?react'
import './ProviderIcon.css';
import { Provider } from '../../generated/src/models';

export default function ProviderIcon({
  onClick,
  provider,
}: {
  onClick?: () => void;
  provider: Provider;
}) {
  return (
   <div className={'ProviderIcon' + (onClick ? ' clickable' : '')}>
      <span className="ProviderSpan" onClick={onClick}> 
        <Grid />
        {provider.color && <div className="circle" style={{ backgroundColor: provider.color }} />}
      </span>
    </div> 
  );
}
